import { useEffect, useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp, Phone } from "lucide-react";
import { CONTACT } from "../lib/contact";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { trackWhatsApp, trackPhone } from "../lib/analytics";

const FloatingButtons = () => {
  const [showTop, setShowTop] = useState(false);

  const onScroll = useCallback(() => {
    setShowTop(window.scrollY > 600);
  }, [setShowTop]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
      <AnimatePresence>
        {showTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="w-11 h-11 rounded-full glass-strong flex items-center justify-center text-white/70 hover:text-white border border-white/10 hover:border-white/30 transition-colors"
            data-testid="scroll-top"
            aria-label="Scroll top"
          >
            <ArrowUp className="w-4 h-4" />
          </motion.button>
        )}
      </AnimatePresence>

      <a
        href={`tel:${CONTACT.phone}`}
        onClick={() => trackPhone("floating")}
        className="sm:hidden w-13 h-13 p-4 rounded-full bg-[#A60056] text-white shadow-[0_8px_32px_rgba(166,0,86,0.45)] flex items-center justify-center"
        data-testid="floating-phone"
        aria-label="Call"
      >
        <Phone className="w-5 h-5" />
      </a>

      <motion.a
        href={CONTACT.whatsapp()}
        target="_blank"
        rel="noreferrer"
        onClick={() => trackWhatsApp("floating")}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.2, type: "spring" }}
        whileHover={{ scale: 1.08 }}
        className="relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center text-white shadow-[0_8px_32px_rgba(37,211,102,0.45)]"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp"
      >
        <WhatsAppIcon className="w-7 h-7" />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      </motion.a>
    </div>
  );
};

export default FloatingButtons;
